export const MoneyRequestPaymentMethodEnum = [
  { value: "EFS", label: "EFS" },
  { value: "RelayCode", label: "Relay Code" },
  { value: "CreditCard", label: "Credit Card" },
  { value: "PaidByDriver", label: "Paid By Driver" },
];
